module.exports = __webpack_public_path__ + "img/whatsapp-logo.8270d9bc.png";